export default "__VITE_ASSET__DoqzvmD3__"